import { render, staticRenderFns } from "./EdgeHeaderPage.vue?vue&type=template&id=3373839f&"
import script from "./EdgeHeaderPage.vue?vue&type=script&lang=js&"
export * from "./EdgeHeaderPage.vue?vue&type=script&lang=js&"
import style0 from "./EdgeHeaderPage.vue?vue&type=style&index=0&scroped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports